export const REQUIRED_FILED_MESSAGE = 'This field is required';
export const EMAIL_VALIDATION_MESSAGE = 'Please enter a valid email';
export const DATE_VALIDATION_MESSAGE = 'Please enter a valid date';

export enum formFieldEnum {
  PHONE = 'Phone',
  EMAIL = 'Email',
  TEXT = 'Text',
  NUMBER = 'Number',
  DATE = 'Date',
  TEXTAREA = 'TextArea',
  SELECT = 'Select',
  CHECKBOX = 'Checkbox',
  RADIO = 'Radio',
  PASSWORD = 'Password'
}
